var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view container",attrs:{"id":"upgrade"}},[_c('digi-landing',{attrs:{"info":_vm.step0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }